import React from 'react';
import logComponent from '../../common/logComponent';
import './FacilityCard.css';

export default function FacilityCard({ facility }) {
  if (logComponent('FacilityCard')) { console.debug('FacilityCard rendered'); }

  return (
    <div className="Facility-Card">
      <p className="Facility-Card__name">{ facility.name }</p>
      <p className="Facility-Card__site-id">Site ID: { facility.salesforceSiteId }</p>
    </div>
  )
}